// src/pages/ChatRedirect.js
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createOrGetConversation } from "../api/chat";

export default function ChatRedirect() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const landlordUserId = params.get("hostId");
  const roomIdRaw = params.get("roomId");
  const roomId = roomIdRaw ? Number(roomIdRaw) : null;

  useEffect(() => {
    if (!landlordUserId || !roomId) {
      console.error("[ChatRedirect] Missing hostId or roomId");
      navigate("/chat", { replace: true });
      return;
    }

    let cancelled = false;

    async function openConversation() {
      try {
        const convo = await createOrGetConversation(
          landlordUserId,
          roomId
        );

        if (cancelled) return;

        if (!convo?.id) {
          throw new Error("Conversation id missing in response");
        }

        // ✅ Redirection vers la conversation
        navigate(`/chat/${convo.id}`, { replace: true });
      } catch (err) {
        console.error("[ChatRedirect] Failed:", err);
        navigate("/chat", { replace: true });
      }
    }

    openConversation();

    return () => {
      cancelled = true;
    };
  }, [landlordUserId, roomId, navigate]);

  return (
    <div className="h-screen flex items-center justify-center text-gray-500">
      Opening conversation…
    </div>
  );
}
